import { render, staticRenderFns } from "./Cached.vue?vue&type=template&id=3a21e1c8"
import script from "./Cached.vue?vue&type=script&lang=js"
export * from "./Cached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports